<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle opacity="0.2" cx="10" cy="10" r="7" fill="currentColor" />
  <path
    d="M15 2L15.8103 4.18973L18 5L15.8103 5.81027L15 8L14.1897 5.81027L12 5L14.1897 4.18973L15 2Z"
    fill="currentColor"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14.9297 10.8402C14.748 10.8632 14.5629 10.875 14.375 10.875C11.9588 10.875 10 8.91625 10 6.5C10 5.97555 10.0923 5.47266 10.2615 5.00667C10.5226 4.2876 10.9669 3.6564 11.5379 3.16948C11.043 3.05854 10.5284 3 10 3C9.6606 3 9.32684 3.02416 9.00035 3.07084C5.60789 3.55592 3 6.4734 3 10C3 13.866 6.13401 17 10 17C12.9864 17 15.536 15.1299 16.5416 12.4968C16.8377 11.7214 17 10.8798 17 10.0003C16.4083 10.4448 15.7002 10.7427 14.9297 10.8402ZM14.0955 12.869C13.1911 14.1577 11.6939 15 10 15C7.23858 15 5 12.7614 5 10C5 7.91145 6.28055 6.12199 8.09934 5.37392C8.03408 5.73947 8 6.1158 8 6.5C8 9.92717 10.7044 12.7227 14.0955 12.869Z"
    fill="currentColor"
  />
  <path
    d="M3.90514 16.0949L3.5 15L3.09486 16.0949L2 16.5L3.09486 16.9051L3.5 18L3.90514 16.9051L5 16.5L3.90514 16.0949Z"
    fill="currentColor"
  />
</svg>
